import { render, staticRenderFns } from "./HMAttachment.vue?vue&type=template&id=4836f9ee&scoped=true&"
import script from "./HMAttachment.vue?vue&type=script&lang=ts&"
export * from "./HMAttachment.vue?vue&type=script&lang=ts&"
import style0 from "./HMAttachment.vue?vue&type=style&index=0&id=4836f9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836f9ee",
  null
  
)

export default component.exports